import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "btn" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]

import { useAzureStore } from "@/stores/azure";
import { useEmbedStore } from "@/stores/embedStore";
import { PageDescription } from "@/types/PageDescriptionListItem";
import { ref, computed, onMounted } from "vue";
import { VueFinalModal } from "vue-final-modal";

const title = "Description";


export default /*@__PURE__*/_defineComponent({
  __name: 'DescriptionModal',
  setup(__props) {

/* eslint-disable */
const azureStore = useAzureStore();

const description = ref<PageDescription | null>(null);

const editDescriptionLink = computed(() => {
  return `https://abb.sharepoint.com/sites/NO-CompetenceLibrary/PA-OGC-KPI/Lists/PageDescriptions/EditForm.aspx?ID=${description.value?.id}`;
});

onMounted(async () => {
  const embedStore = useEmbedStore();
  await embedStore.getPageDescription().then((res) => {
    if (res) {
      // Update links in the description conten
      const updatedContent = updateLinksInDescription(res.Content);
      description.value = { ...res, content: updatedContent };
    } else {
      description.value = {
        id: 0,
        content: "Unable to load description",
        title: "",
        Content: "",
      };
    }
  });
  await azureStore.loadIsUserOwner();
});

const updateLinksInDescription = (htmlContent: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  doc
    .querySelectorAll("a[href^='/sites/'], img[src^='/sites/']")
    .forEach((el) => {
      const attr = el.tagName === "A" ? "href" : "src";
      el.setAttribute(
        attr,
        `https://abb.sharepoint.com${el.getAttribute(attr)}`
      );
    });

  return doc.body.innerHTML;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "desc-modal",
    "content-class": "desc-modal-content",
    "overlay-transition": "vfm-fade",
    "content-transition": "vfm-fade"
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(title)),
        _createElementVNode("div", _hoisted_2, [
          (_unref(azureStore).isUserOwner())
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: editDescriptionLink.value,
                target: "_blank"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: () => close()
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
          ], 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          innerHTML: description.value?.content
        }, null, 8, _hoisted_5)
      ])
    ]),
    _: 1
  }))
}
}

})